module.exports = __webpack_public_path__ + "img/ae9d1a7.png";